import { createClient, SupabaseClient } from "@supabase/supabase-js";
import { v4 as uuid } from 'uuid';
import logger from "../utils/logger";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;
const supabaseEmail = import.meta.env.VITE_SUPABASE_EMAIL as string;
const supabasePassword = import.meta.env.VITE_SUPABASE_PASSWORD as string;

// Supabase URL validation
if (!supabaseUrl) {
    console.error('[Supabase] ERROR: VITE_SUPABASE_URL is not set!');
}

const supabase: SupabaseClient = createClient(supabaseUrl, supabaseAnonKey);

logger.debug('supabase', supabase);

const BUCKET_NAME = "bank_statements_to_parse";

export async function uploadFile(file: File): Promise<string> {
    try {
        if (!file) {
            throw new Error("No file provided");
        }

        const { data: { user } } = await supabase.auth.getUser();
        if (!user) {
            const { data, error } = await supabase.auth.signInWithPassword({
                email: supabaseEmail,
                password: supabasePassword,
            });
            if (error) throw error;
        }

        const uniqueFileName = uuid() + "." + file.name.split(".").pop();

        const { data, error } = await supabase.storage
            .from(BUCKET_NAME)
            .upload(uniqueFileName, file, {
                cacheControl: "3600",
                upsert: false,
            });

        if (error) {
            logger.error("Supabase upload error:", error);
            throw new Error(error.message);
        }

        const { data: publicData } = supabase.storage
            .from(BUCKET_NAME)
            .getPublicUrl(uniqueFileName);

        return publicData.publicUrl;
    } catch (err) {
        logger.error("File upload failed:", err);
        throw err;
    }
}
